import { useState } from 'react'
import { DropIcon, AnimatedHeight } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import capitalize from 'lodash/capitalize'
import { useTranslation } from 'react-i18next'

export const MenuDrawer = ({
  title,
  subtitle,
  startOpen = false,
  children,
  doNotCapitalize,
  ...props
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(startOpen)

  const translatedTitle = doNotCapitalize
    ? t(`editor.menus.properties.elements.titles.${title}`, title)
    : capitalize(t(`editor.menus.properties.elements.titles.${title}`, title))

  return (
    <Flex borderBottom="1px solid" borderColor="gray4" column {...props}>
      <Flex
        justify="space-between"
        align="center"
        height="54px"
        padding="0 12px"
        open={open}
        onClick={() => setOpen(!open)}
        clickable
      >
        <Flex>
          <Text weight="600">{translatedTitle}</Text>
          {subtitle && (
            <Text margin="0 0 0 6px" color="gray2">
              {capitalize(subtitle)}
            </Text>
          )}
        </Flex>
        <DropIcon fill="gray1" up={open} />
      </Flex>
      <AnimatedHeight duration={250} height={open ? 'auto' : 0}>
        {open && <Flex column>{children}</Flex>}
      </AnimatedHeight>
    </Flex>
  )
}

export default MenuDrawer
